import { Instance, types } from 'mobx-state-tree';

export const FindTicketByNumberStore = types
    .model('findTicketByNumber', {
        ticketNumber: types.optional(types.string, "")
    }).actions((self) => {
        const setTicketNumberText = (value: string): void => {
            self.ticketNumber = value;
        }

        return {
            setTicketNumberText
        }
    });


export type IFindTicketByNumber = Instance<typeof FindTicketByNumberStore>;